import React, { CSSProperties, useContext, useCallback, useMemo, MouseEvent } from 'react'

import RenderContext from './RenderContext'

import {
  ILayout_Render,
  ILayout_Cell_Props_Image,
} from '../types/layout'

import {
  LAYOUT_IMAGE_SIZE_FIELD_DEFAULT,
  LAYOUT_IMAGE_SIZE_UNIT_DEFAULT,
  LAYOUT_IMAGE_SIZE_AMOUNT_DEFAULT,
} from '../constants'

import {
  flattenLink,
  renderMagicString,
  getContentFromRaw,
} from '../texteditor/utils'

import {
  isImageExtension,
} from '../utils/file'

import {
  StorageFile,
} from '../utils/storage'

/*

  RENDER

*/

const getStyles: {
  (props: any): Record<string, CSSProperties>,
} = ({
  sizeField,
  sizeAmount,
  sizeUnit,
}) => ({
  image: sizeField == 'width' ? {
    width: `${sizeAmount}${sizeUnit}`,
    maxWidth: `100%`,
  } : {
    maxHeight: `${sizeAmount}${sizeUnit}`,
    maxWidth: `100%`,
  },
  caption: {
    marginTop: '10px',
    // width: '100%',
    fontSize: '9pt',
    color: '#666',
    textAlign: 'center',
  },
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  }
})

const ImageComponent: ILayout_Render<ILayout_Cell_Props_Image> = ({
  cell,
}) => {
  const {
    file,
    link,
    sizeField = LAYOUT_IMAGE_SIZE_FIELD_DEFAULT,
    sizeAmount = LAYOUT_IMAGE_SIZE_AMOUNT_DEFAULT,
    sizeUnit = LAYOUT_IMAGE_SIZE_UNIT_DEFAULT,
    caption,
  } = cell.data
  const styles = getStyles({
    sizeField,
    sizeAmount,
    sizeUnit,
  })
  const {
    project,
    token,
    disableLinks,
    preview,
    values,
    options,
  } = useContext(RenderContext)
  const url = useMemo(() => {
    if(!file) return ''
    const filename = file.meta && file.meta.filename ? file.meta.filename : ((file as any).filename || '')
    if(!isImageExtension(filename)) return ''
    return StorageFile(file, token).url({
      breakCache: options.breakImageCache,
    })
  }, [
    project,
    token,
    file,
    options,
  ])
  const linkUrl = useMemo(() => {
    if(!link) return ''
    let result = flattenLink(link)
    const url = preview && values ? renderMagicString(result, values) : result
    return url
  }, [
    link,
    preview,
    values,
  ])
  const onClick = useCallback((e: MouseEvent) => {
    if(!disableLinks) return
    e.preventDefault()
    e.stopPropagation()
  }, [
    disableLinks,
  ])
  if(!url) return null
  const img = (
    <img
      className="Image-Element" 
      style={ styles.image }
      src={ url }
    />
  )

  let renderElem = img

  if(caption) {
    renderElem = (
      <div className="Image-Container" style={{
        width: '100%',
        }}
      >
        { img }
        <div className="Image-Caption" style={ styles.caption }>{ caption }</div>
      </div>
    )
  }
  if(link && linkUrl) {
    return (
      <a
        href={ linkUrl }
        target={ `_${link.target || 'blank'}` }
        style={{
          width: '100%',
        }}
        className="Image-Link" 
        onClick={ onClick }
      >
        { renderElem }
      </a>
    )
  }
  else {
    return renderElem
  }
}

export default ImageComponent 